import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  const quickLinks = [
    { id: 'hero', label: 'Home' },
    { id: 'about', label: 'About' },
    { id: 'services', label: 'Packages' },
    { id: 'portfolio', label: 'Our Work' }
  ];

  return (
    <footer className="bg-[#050505] border-t border-white/5" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_clipcraft-270/artifacts/c5t7ui84_GTMC_Logo-removebg-preview.png"
              alt="Go-To Media Collective"
              className="h-14 w-auto mb-5"
            />
            <p className="text-[#a0a0a0] max-w-md leading-relaxed">
              Transforming raw footage into stunning, professional videos that captivate audiences and
              elevate brand presence.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-5 uppercase tracking-[0.12em] text-sm">Quick Links</h3>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-[#a0a0a0] hover:text-[#d4af37] transition-colors text-left"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Packages */}
          <div>
            <h3 className="text-white font-semibold mb-5 uppercase tracking-[0.12em] text-sm">Packages</h3>
            <ul className="space-y-3">
              <li className="text-[#a0a0a0]">Exposure — $750</li>
              <li className="text-[#a0a0a0]">Over Exposed — $1,250</li>
              <li className="text-[#a0a0a0]">Celebrity — $2,500</li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-[#d4af37] hover:text-[#f4d66f] transition-colors font-medium text-left"
                >
                  Custom Solutions
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#a0a0a0] text-sm">
              © {currentYear} Go-To Media Collective. All rights reserved.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-[#a0a0a0] hover:text-[#d4af37] transition-colors text-sm">
                Privacy Policy
              </a>
              <a href="#" className="text-[#a0a0a0] hover:text-[#d4af37] transition-colors text-sm">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
